import React from "react";
import Navbar from "./header";
import Footer from "./footer";

export default function Layout({ children }: any) {
  return (
    <div>
      <Navbar />
      {children}
      <Footer />
    </div>
  );
}
